/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useState } from 'react';
import ThreeDotsLoader from '../../../Components/LoadingDots';

function AddAdjustment({
    addAdjustmentModal, setAddAdjustmentModal, adjustmentEntryInformation, setAdjustEntryInformation, handleAdjustment, setthreedotsLoader, threedotsLoader,
}) {
    const toggleState = {
        type: false,
    };

    const [toggle, settoggle] = useState(toggleState);

    const handleDropdownStatus = () => {
        settoggle(toggleState);
    };

    const InputChange = (e, index) => {
        // e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setAdjustEntryInformation((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setAdjustEntryInformation((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const handleToggle = (key) => {
        handleDropdownStatus();
        const val = key === 'start_date' ? 'end_date' : 'start_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${addAdjustmentModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="addadjustment" tabIndex="-1" aria-labelledby="modal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[318px] min-w-[318px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-3.5 rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#000000] text-center w-full" id="exampleModalScrollableLabel1">
                            Add Adjustment Entry
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setAddAdjustmentModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body px-6 pt-7 pb-4">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="comment"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                onChange={(e) => {
                                    InputChange(e);
                                }}
                            />
                            <label htmlFor="comment" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Comment</label>
                        </div>
                        <div className="relative w-full mt-5">
                            <input
                                type="number"
                                id="amount"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                onChange={(e) => {
                                    InputChange(e);
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                            <label htmlFor="amount" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Amount</label>
                        </div>
                        <div className="dropdown relative w-full mt-5">
                            <button
                                type="button"
                                id="territory20"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                onClick={() => handleToggle('type')}
                            >
                                <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    Type
                                </span>
                                {adjustmentEntryInformation.type}
                            </button>
                            <img src="/images/chevron-down-category.svg" alt="icon" className="absolute top-[22px] right-5" />
                            <ul className={`dropdown-menu  ${toggle.type ? 'show' : 'hidden'} w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="territory20">
                                <li
                                    className="px-3 w-full pt-3"
                                    onClick={() => {
                                        setAdjustEntryInformation((prevState) => ({
                                            ...prevState,
                                            type: 'CREDIT',
                                        }));
                                        settoggle((prevState) => ({
                                            ...prevState,
                                            type: false,
                                        }));
                                    }}
                                >
                                    <a className="dropdown-item text-lg font-normal text-[Credit] w-full inline-block" href="#">Credit</a>
                                </li>
                                <li
                                    className="px-3 w-full pt-3"
                                    onClick={() => {
                                        setAdjustEntryInformation((prevState) => ({
                                            ...prevState,
                                            type: 'DEBIT',
                                        }));
                                        settoggle((prevState) => ({
                                            ...prevState,
                                            type: false,
                                        }));
                                    }}
                                >
                                    <a className="dropdown-item text-lg font-normal text-[Credit] w-full inline-block" href="#">Debit</a>
                                </li>
                            </ul>
                        </div>
                        <button
                            type="button"
                            className="mt-8 rounded-lg bg-[#555259] py-3 w-full text-lg font-lg text-[#FFFFFF]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            data-bs-toggle="modal"
                            data-bs-target="#entryadded"
                            onClick={() => handleAdjustment()}
                        >
                            {threedotsLoader ? <div className="pl-[105px]"><ThreeDotsLoader /></div> : 'Submit'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddAdjustment;
